import { FC, useEffect, useMemo, useState } from 'react';

import { BaseSingleSearchAutocomplete, BaseSpinner } from 'wbs-components-lib';

import { useGetProviderSlotsByTournamentIdQuery } from '@services';

import { ActiveTournamentSlotPickerProps } from './types';
import { getSortedSlots } from './utils';

import { SlotModel } from 'v2/types/SlotModel';

export const ActiveTournamentSlotPicker: FC<ActiveTournamentSlotPickerProps> = ({ gameId, tournamentId, ...props }) => {
  const isTournamentIdExisting = !!tournamentId;

  const {
    data,
    isLoading: isSlotsLoading,
    isFetching: isSlotsFetching,
    isSuccess: isSlotsLoaded,
  } = useGetProviderSlotsByTournamentIdQuery(tournamentId, {
    skip: !isTournamentIdExisting,
  });

  const [providerSlots, setProviderSlots] = useState<SlotModel[]>([]);

  useEffect(() => {
    if (isSlotsLoaded) {
      setProviderSlots(data);
    }
  }, [isSlotsLoaded, data]);

  const sortedTournamentSlots = useMemo(() => getSortedSlots(providerSlots), [providerSlots]);

  if (!isTournamentIdExisting) {
    return null;
  }

  const isPickerProcessing = isSlotsFetching || isSlotsLoading || sortedTournamentSlots.length === 0;

  if (isPickerProcessing) {
    return <BaseSpinner type="linear" />;
  }

  const getSlotByGameId = (searchGameId: string) => providerSlots.find((slot) => slot.identifier === searchGameId);

  return (
    <BaseSingleSearchAutocomplete<SlotModel>
      {...props}
      value={getSlotByGameId(gameId)}
      getOptionLabel={(option) => option.title}
      options={sortedTournamentSlots}
      groupByFunction={(option) => option.providerName}
    />
  );
};
